var map = {
	"./arrow-down-blue.svg": 256,
	"./arrow-down-grey.svg": 257,
	"./arrow-right-white.png": 258,
	"./arrow-right.svg": 259,
	"./ata-logo.svg": 260,
	"./automata-logo.png": 261,
	"./big_unicorn.png": 262,
	"./blue-loader.svg": 263,
	"./circle-grey.svg": 264,
	"./circle.svg": 265,
	"./coinbaseWalletIcon.svg": 100,
	"./dropdown-blue.svg": 266,
	"./dropdown.svg": 267,
	"./dropup-blue.svg": 268,
	"./ethereum-logo.png": 269,
	"./fortmaticIcon.png": 101,
	"./link.svg": 270,
	"./magnifying-glass.svg": 271,
	"./menu.svg": 272,
	"./metamask.png": 135,
	"./noise.png": 273,
	"./orange-loader.svg": 274,
	"./plus-blue.svg": 275,
	"./plus-grey.svg": 276,
	"./portisIcon.png": 102,
	"./question-mark.svg": 277,
	"./question.svg": 278,
	"./spinner.svg": 279,
	"./token-list-logo.png": 280,
	"./token-list/lists-dark.png": 281,
	"./token-list/lists-light.png": 282,
	"./token-logo.png": 283,
	"./tokens/ata.png": 119,
	"./tokens/busd.png": 136,
	"./tokens/dai.png": 137,
	"./tokens/usdc.png": 106,
	"./tokens/usdt.png": 107,
	"./tokens/weth.png": 120,
	"./tokens/wmatic.png": 138,
	"./trustWallet.png": 284,
	"./walletConnectIcon.svg": 103,
	"./x.svg": 285,
	"./xata-brand.png": 286,
	"./xata-brand.svg": 287,
	"./xata-logo.png": 134,
	"./xl_uni.png": 288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;